// src/pages/Reports/IssuanceReporting/ReconciliationDiscrepancy/ResolveDiscrepancyModal.tsx
// RPT-010 (README.md mục 7) — đánh dấu 1 chênh lệch đã xử lý, kèm ghi chú cách xử lý.

import React, { useState } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';

import { resolveTicketDiscrepancyApi } from 'helpers/fakebackend_helper';
import { TicketDiscrepancy } from '../shared/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

interface ResolveDiscrepancyModalProps {
  isOpen: boolean;
  target: TicketDiscrepancy | null;
  onClose: () => void;
  onResolved: () => void;
}

const ResolveDiscrepancyModal: React.FC<ResolveDiscrepancyModalProps> = ({ isOpen, target, onClose, onResolved }) => {
  const [resolutionNote, setResolutionNote] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleToggle = () => {
    if (submitting) return;
    setResolutionNote('');
    onClose();
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!target) return;
    if (!resolutionNote.trim()) {
      toast.error(st('vui_long_nhap_ghi_chu_xu_message'));
      return;
    }
    setSubmitting(true);
    try {
      await resolveTicketDiscrepancyApi(target.id, { resolutionNote: resolutionNote.trim() });
      toast.success(st('da_xu_ly_chenh_lech_message'));
      setResolutionNote('');
      onResolved();
    } catch (error: any) {
      toast.error(error?.message || st('khong_the_xu_ly_chenh_lech_message'));
    } finally {
      setSubmitting(false);
    }
  };

  if (!target) return null;

  return (
    <Modal isOpen={isOpen} toggle={handleToggle} centered>
      <ModalHeader className="bg-light p-3" toggle={handleToggle}>{st('xu_ly_chenh_lech_title')}{target.id}</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="mb-3 text-muted">
            {target.discrepancyTypeName} {st('chenh_lech_text_2')} {target.discrepancyQuantity.toLocaleString('vi-VN')} {st('ve_text_2')}
          </div>
          <FormGroup>
            <Label>{st('ghi_chu_xu_ly_label')} <span className="text-danger">*</span></Label>
            <Input
              required
              type="textarea"
              rows={3}
              value={resolutionNote}
              onChange={(e) => setResolutionNote(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <Button color="light" onClick={handleToggle} disabled={submitting}>{st('huy_column')}</Button>
            <Button color="success" type="submit" disabled={submitting}>
              {submitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
              {st('xac_nhan_da_xu_ly_button')}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default ResolveDiscrepancyModal;
